import {
  isActivitySkippedOrCancelled,
  UserTimelinesModal,
} from '@wilson/interfaces';
import { cloneDeep } from 'lodash';

export function filterUserSkippedActivities(
  userTimeline: UserTimelinesModal,
): UserTimelinesModal {
  const updatedShifts = userTimeline.shifts.map((shift) => {
    const clonedShift = cloneDeep(shift);

    const shiftHasSkippedActivities = clonedShift.activities.some(
      isActivitySkippedOrCancelled,
    );

    if (shiftHasSkippedActivities) {
      const activitiesNotSkipped = clonedShift.activities.filter(
        (activity) => !isActivitySkippedOrCancelled(activity),
      );
      clonedShift.activities = activitiesNotSkipped;
    }

    return clonedShift;
  });
  return { ...userTimeline, shifts: updatedShifts };
}
